import React, { useState } from 'react';

const TAB_DATA = {
  Overview: { content: 'Company overview and general KPIs for FY 2025.' },
  Analytics: {
    subTabs: {
      Traffic: { value: '1.24M visits', detail: 'Monthly average web traffic in Q4 2025' },
      Revenue: {
        quarters: {
          'Q1 2025': '₹18,42,000',
          'Q2 2025': '₹21,87,500',
          'Q3 2025': '₹24,10,000',
          'Q4 2025': '₹31,56,800',
        }
      },
      Conversions: { value: '3.8%', detail: 'Average conversion rate Q4 2025' },
    }
  },
  Reports: { content: 'Downloadable reports and audit logs.' },
  Settings: { content: 'Account and integration settings.' },
};

// Expected answer: value shown for Q3 2025 Revenue
const EXPECTED_ANSWER = '₹24,10,000';

export default function C07_TabNavigate({ onComplete }) {
  const [activeTab, setActiveTab] = useState('Overview');
  const [activeSubTab, setActiveSubTab] = useState('Traffic');
  const [answer, setAnswer] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const normNum = (s) => s.trim().replace(/[₹,\s]/g, '');

  const handleSubmit = () => {
    if (!answer.trim()) return;
    setSubmitted(true);
    const pass = normNum(answer) === normNum(EXPECTED_ANSWER);
    onComplete({
      score: pass ? 100 : 0,
      details: { answer: { expected: EXPECTED_ANSWER, got: answer.trim(), pass } },
      passed: pass,
    });
  };

  return (
    <div className="ab-challenge-ui">
      <div className="ab-tabs-bar">
        {Object.keys(TAB_DATA).map(tab => (
          <button key={tab} className={`ab-tab ${activeTab === tab ? 'ab-tab-active' : ''}`}
            onClick={() => setActiveTab(tab)} disabled={submitted}>{tab}</button>
        ))}
      </div>

      <div className="ab-tab-panel">
        {activeTab === 'Overview' && (
          <p className="ab-tab-content">{TAB_DATA.Overview.content}</p>
        )}
        {activeTab === 'Analytics' && (
          <div>
            <div className="ab-inner-tabs-bar">
              {Object.keys(TAB_DATA.Analytics.subTabs).map(sub => (
                <button key={sub} className={`ab-inner-tab ${activeSubTab === sub ? 'ab-inner-tab-active' : ''}`}
                  onClick={() => setActiveSubTab(sub)} disabled={submitted}>{sub}</button>
              ))}
            </div>
            <div className="ab-inner-tab-panel">
              {activeSubTab === 'Traffic' && (
                <div className="ab-stat-card">
                  <div className="ab-stat-val">{TAB_DATA.Analytics.subTabs.Traffic.value}</div>
                  <div className="ab-stat-lbl">{TAB_DATA.Analytics.subTabs.Traffic.detail}</div>
                </div>
              )}
              {activeSubTab === 'Revenue' && (
                <div>
                  <div className="ab-revenue-title">Quarterly Revenue</div>
                  <table className="ab-table ab-table-sm">
                    <thead><tr><th>Quarter</th><th>Revenue</th></tr></thead>
                    <tbody>
                      {Object.entries(TAB_DATA.Analytics.subTabs.Revenue.quarters).map(([q, v]) => (
                        <tr key={q} className={q === 'Q3 2025' ? 'ab-row-highlight' : ''}>
                          <td><strong>{q}</strong></td><td>{v}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              {activeSubTab === 'Conversions' && (
                <div className="ab-stat-card">
                  <div className="ab-stat-val">{TAB_DATA.Analytics.subTabs.Conversions.value}</div>
                  <div className="ab-stat-lbl">{TAB_DATA.Analytics.subTabs.Conversions.detail}</div>
                </div>
              )}
            </div>
          </div>
        )}
        {activeTab === 'Reports' && <p className="ab-tab-content">{TAB_DATA.Reports.content}</p>}
        {activeTab === 'Settings' && <p className="ab-tab-content">{TAB_DATA.Settings.content}</p>}
      </div>

      <div className="ab-answer-row">
        <label className="ab-label">Q3 2025 Revenue value:</label>
        <input value={answer} onChange={e => setAnswer(e.target.value)} className="ab-input ab-answer-input"
          placeholder="e.g. 24,10,000" disabled={submitted} />
        {!submitted
          ? <button className="ab-action-btn" onClick={handleSubmit}>Submit Answer</button>
          : <div className="ab-submitted-badge">✓ Answer Submitted</div>
        }
      </div>
    </div>
  );
}
